import { ReactComponent as Logo } from 'assets/brand/horizontal.svg'

function LayoutCentered(_props) {
  return (
    <div className="min-h-screen min-w-full flex flex-col justify-center items-center text-white fill-white bg-default">
      <div className="min-h-screen flex flex-col justify-evenly items-stretch w-full w-[90%] md:max-w-[36rem] ml-4 mr-4">
        <div className="flex flex-grow flex-shrink items-center justify-center w-10/12 mx-auto">
          <Logo className="w-3/4 md:w-full h-auto py-6" />
        </div>
        {_props.children}
        <div className="flex flex-grow flex-shrink" />
      </div>
    </div>
  )
}

export default LayoutCentered
